const popupGalleryLazy = {
  init() {
    const popup = document.getElementById("jsGalleryWrap");

    if (!popup) return;

    const mainList = popup.querySelector<HTMLElement>(
      "#mainImagePopup .splide__list",
    );

    if (!mainList) return;

    let activated = false;

    const loadImage = (img: HTMLImageElement) => {
      const src = img.dataset.src;

      if (!src) return;

      img.loading = "eager";
      img.src = src;

      delete img.dataset.src;
    };

    const loadActiveSlide = () => {
      const slide =
        mainList.querySelector<HTMLElement>(
          ":scope > .splide__slide.is-active",
        ) || mainList.querySelector<HTMLElement>(":scope > .splide__slide");

      if (!slide) return;

      slide
        .querySelectorAll<HTMLImageElement>("img[data-src]")
        .forEach(loadImage);
    };

    const activate = () => {
      loadActiveSlide();

      if (activated) return;

      activated = true;

      const thumbsTrack = popup.querySelector<HTMLElement>(
        "#thumbnailsPopup .splide__track",
      );

      const thumbSlides = popup.querySelectorAll<HTMLElement>(
        "#thumbnailsPopup .splide__slide",
      );

      if (thumbsTrack && typeof IntersectionObserver !== "undefined") {
        const observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;

              entry.target
                .querySelectorAll<HTMLImageElement>("img[data-src]")
                .forEach(loadImage);

              observer.unobserve(entry.target);
            });
          },
          {
            root: thumbsTrack,
            rootMargin: "150px 0px",
            threshold: 0,
          },
        );

        thumbSlides.forEach((slide) => {
          observer.observe(slide);
        });
      } else {
        popup
          .querySelectorAll<HTMLImageElement>("#thumbnailsPopup img[data-src]")
          .forEach(loadImage);
      }
    };

    const slideObserver = new MutationObserver(() => {
      if (!activated) return;

      loadActiveSlide();
    });

    slideObserver.observe(mainList, {
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    });

    document
      .getElementById("jsOpenGallery")
      ?.addEventListener("click", activate);

    popup.addEventListener("gallery:open", activate);
  },
};

export default popupGalleryLazy;
